/**
 * Exit Intent Popup — Kohde
 * Abre quando o carrinho lateral é fechado.
 * Mostra apenas uma vez por sessão do navegador.
 */
(function () {
  'use strict';

  var SESSION_KEY = 'kohde_exit_popup_shown';

  /* Aguarda o DOM estar pronto */
  function init() {
    /* ── 1. Não mostrar duas vezes na mesma sessão ── */
    if (sessionStorage.getItem(SESSION_KEY)) return;

    /* ── 2. Elementos do popup ── */
    var overlay = document.getElementById('exit-intent-overlay');
    if (!overlay) return; /* Popup não está no DOM (seção desativada) */

    var closeBtn = document.getElementById('exit-intent-popup__close');
    var form = document.getElementById('exit-intent-form');
    var emailInput = document.getElementById('exit-intent-email');
    var submitBtn = document.getElementById('exit-intent-submit');
    var errorMsg = document.getElementById('exit-intent-error');
    var formWrap = document.getElementById('exit-intent-popup__form-wrap');
    var successWrap = document.getElementById('exit-intent-popup__success');
    var copyBtn = document.getElementById('exit-intent-copy-btn');
    var copiedMsg = document.getElementById('exit-intent-copied-msg');

    var config = window.exitIntentConfig || {};
    var couponCode = config.couponCode || 'EXTRA';

    /* ── 3. Abrir popup ── */
    function openPopup() {
      if (sessionStorage.getItem(SESSION_KEY)) return;
      sessionStorage.setItem(SESSION_KEY, '1');

      document.removeEventListener('kohde:cart-drawer-closed', onDrawerClosed);

      overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { emailInput && emailInput.focus(); }, 150);
    }

    /* ── 4. Fechar popup ── */
    function closePopup() {
      overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    closeBtn && closeBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-visible')) closePopup();
    });

    /* ── 5. Gatilho: fechar o carrinho lateral ── */
    /* O popup só abre se o carrinho foi aberto primeiro */
    var cartWasOpened = false;
    var cartDrawerEl = document.querySelector('cart-drawer');

    if (cartDrawerEl) {
      /* Marca quando o drawer abre */
      var openObserver = new MutationObserver(function () {
        if (cartDrawerEl.classList.contains('active')) {
          cartWasOpened = true;
        }
      });
      openObserver.observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
    }

    function onDrawerClosed() {
      if (!cartWasOpened) return; /* Ignora se o carrinho nunca foi aberto */
      cartWasOpened = false;
      setTimeout(openPopup, 300);
    }

    document.addEventListener('kohde:cart-drawer-closed', onDrawerClosed);

    /* ── 8. Formulário de email ── */
    /* Valida o email; se inválido bloqueia o submit.
       Se válido, deixa o formulário submeter normalmente para o iframe
       (o Shopify injeta o token Turnstile automaticamente no {% form 'customer' %}).
       Mostramos o cupom imediatamente sem esperar resposta do servidor. */
    form && form.addEventListener('submit', function (e) {
      var email = (emailInput.value || '').trim();

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        e.preventDefault();
        errorMsg && errorMsg.classList.add('is-visible');
        emailInput.focus();
        return;
      }

      errorMsg && errorMsg.classList.remove('is-visible');
      submitBtn.disabled = true;

      /* Exibe o cupom após a submissão natural do form para o iframe */
      setTimeout(showSuccessState, 80);
    });

    /* ── 9. Estado de sucesso: exibe o cupom ── */
    function showSuccessState() {
      formWrap && formWrap.classList.add('is-hidden');
      successWrap && successWrap.classList.add('is-visible');
    }

    /* ── 10. Copiar cupom ── */
    copyBtn && copyBtn.addEventListener('click', function () {
      var code = couponCode;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(onCopied).catch(legacyCopy);
      } else {
        legacyCopy();
      }
    });

    function legacyCopy() {
      var el = document.getElementById('exit-intent-coupon');
      if (!el) return;
      var range = document.createRange();
      range.selectNode(el);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      onCopied();
    }

    function onCopied() {
      if (copiedMsg) copiedMsg.textContent = 'Cupom copiado!';
      if (copyBtn) copyBtn.textContent = '✓ Copiado';
      setTimeout(function () {
        if (copiedMsg) copiedMsg.textContent = '';
        if (copyBtn) copyBtn.textContent = 'Copiar';
      }, 3000);
    }
  }

  /* Garante que o DOM já está carregado antes de rodar */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
